var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconThumbsDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4907 0.00012207H12.1667C11.8025 0.00012207 11.5046 0.298039 11.5046 0.662159V6.62049C11.5046 6.98461 11.8025 7.28253 12.1667 7.28253H13.4907V0.00012207ZM0.362546 4.71383C0.289722 4.87933 0.25 5.05808 0.25 5.24346V5.95846C0.25 6.6867 0.845833 7.28253 1.57407 7.28253H5.21528L4.6062 10.361C4.5731 10.5066 4.59296 10.6655 4.65917 10.7979C4.81143 11.0959 5.00343 11.3673 5.24176 11.6056L5.5463 11.9168L9.78995 7.67313C10.0415 7.42156 10.1806 7.08392 10.1806 6.73304V1.54929C10.1806 0.695261 9.48542 0.00012207 8.63139 0.00012207H3.26889C2.79884 0.00012207 2.36852 0.245076 2.13019 0.642298L0.362546 4.71383Z",
    fill: "white",
    fillOpacity: 0.54
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconThumbsDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_thumbs_down.877ab12219ae218abec9d3d3a5005f0e.svg";